/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceCommandTypeDto { 
    deviceCommandType?: DeviceCommandTypeDto.DeviceCommandTypeEnum;
}
export namespace DeviceCommandTypeDto {
    export const DeviceCommandTypeEnum = {
        DropOffRelease: 'DROP_OFF_RELEASE',
        DropOffReleaseLong: 'DROP_OFF_RELEASE_LONG'
    } as const;
    export type DeviceCommandTypeEnum = typeof DeviceCommandTypeEnum[keyof typeof DeviceCommandTypeEnum];
}


